var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhantomSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 10,
    fill: "#1E2D3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8399 34C17.9026 34 20.2042 31.2013 21.5777 28.9897C21.4107 29.479 21.3179 29.9683 21.3179 30.4381C21.3179 31.7297 22.0232 32.6496 23.4153 32.6496C25.3271 32.6496 27.3689 30.8882 28.4269 28.9897C28.3527 29.2638 28.3156 29.5182 28.3156 29.753C28.3156 30.6533 28.7982 31.2209 29.7818 31.2209C32.8816 31.2209 36 25.4474 36 20.398C36 16.4641 34.1067 13 29.355 13C21.0023 13 12 23.7251 12 30.6533C12 33.3737 13.3921 34 14.8399 34ZM26.4779 19.9674C26.4779 18.9888 26.9976 18.3038 27.7587 18.3038C28.5011 18.3038 29.0209 18.9888 29.0209 19.9674C29.0209 20.946 28.5011 21.6505 27.7587 21.6505C26.9976 21.6505 26.4779 20.946 26.4779 19.9674ZM30.4501 19.9674C30.4501 18.9888 30.9699 18.3038 31.7308 18.3038C32.4733 18.3038 32.993 18.9888 32.993 19.9674C32.993 20.946 32.4733 21.6505 31.7308 21.6505C30.9699 21.6505 30.4501 20.946 30.4501 19.9674Z",
    fill: "#546A7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhantomSquare);
export default __webpack_public_path__ + "static/media/phantomSquare.96e77166ef380d841ac01f081a195135.svg";
export { ForwardRef as ReactComponent };